const getTotalPrice = (price, quantity) => {
  if (!price || quantity < 2) return price;

  const currencySymbol = price[0];
  const parsedPrice = Number(price.substring(1));
  const total = `${parsedPrice * quantity}`;
  const parsedTotal = parseFloat(total).toFixed(2);
  return `${currencySymbol}${parsedTotal}`;
};

const getSelectedVariant = (contextVariant, variants) => {
  if (!variants || !variants.length) return {};
  const selectedVariantId = contextVariant || variants[0].variantId;

  return variants.find(({ variantId }) => variantId === selectedVariantId) || {};
};

export { getTotalPrice, getSelectedVariant };
